var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m23.871 7.935-3.13 2.374v15.893l3.131-2.552V7.936zm-6.528 4.951-2.862 2.17v13.362l1.787 1.432 1.075-.877V12.886zm-5.724 4.34-3.13 2.375v4.014l3.13 2.51v-8.897zM7.88 1.823C9.52 1.36 11.984 1 15.553 1c3.563 0 6.221.27 8.102.61 1.862.338 3.003.753 3.498 1.07l.205.133v19.149l-.165.134-10.643 8.676-.28.228-.283-.226-10.823-8.676L5 21.964V3.472l.06-.105c.164-.279.485-.55.926-.8.452-.257 1.074-.516 1.893-.746zm7.405 1.235.492.581.67-.58-.67-.582-.492.581zm9.57 1.923-.626-.716.625-.626.626.626-.625.716zM7.951 15.444V5.338l1.7-.671 2.863 1.297 2.772.536v3.757l-3.667 2.817.895-2.817 1.207-1.431V7.26l-1.7 1.566-.402-2.326-2.236.76.627.85v2.147l-1.343 2.012.984 1.028v.85l-1.699 1.296zm8.766-6.216V6.277l1.208.223 4.248-1.833-.402.894-5.054 3.668zm1.655.313.716.717.671-.716-.67-.714-.716.715zM6.61 4.981l-.626-.716.626-.626.76.626-.76.716zm-.626 6.171.626.672.76-.67-.76-.672-.626.671zm.626 8.05-.626-.715.626-.715.76.715-.76.716zm5.903-5.142.536.67.67-.67-.67-.76-.537.76z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtm);
export default __webpack_public_path__ + "static/media/ATM.7e092f1c44648cfac7a042a1dae23c2b.svg";
export { ForwardRef as ReactComponent };